@if (seatDetails) {
  {{humanReadableSeatDetails(seatDetails, seatTranslation, displayedSeatingInformation, ('language.locale' | transloco))}}
}